import React from 'react'

const ContentHeading = ({ icon, subtitle, title, text, imageSrc }) => {
  return (
    <div className="dealmed-content-heading">
      <div className="dealmed-content-heading__top">
        <p className="dealmed-content-heading__subtitle">{subtitle}</p>
      </div>
      <div className="dealmed-content-heading__middle">
        <h2 className="dealmed-content-heading__title">{title}</h2>
        <p className="dealmed-content-heading__text">{text}</p>
      </div>
      {imageSrc !== undefined ? (
        <div className="dealmed-content-heading__bottom">
          <img
            src={imageSrc.fields?.file?.url}
            className="dealmed-content-heading__image"
            alt=""
            loading="lazy"
          />
        </div>
      ) : null}
    </div>
  )
}

export default ContentHeading
